import { amazon } from "@/i18n/en-us/components/salesChannelManagementApp/amazon";
import { tiktok } from "@/i18n/en-us/components/salesChannelManagementApp/tiktok";
import { molliePos } from "@/i18n/en-us/components/salesChannelManagementApp/mollie-pos";
import { product } from "@/i18n/en-us/components/salesChannelManagementApp/product";
import { prices } from "@/i18n/en-us/components/salesChannelManagementApp/prices";
import { tracking } from "@/i18n/en-us/components/salesChannelManagementApp/tracking";
import { shopify } from "@/i18n/en-us/components/salesChannelManagementApp/shopify";
import { orders } from "@/i18n/en-us/components/salesChannelManagementApp/orders";
import { stock } from "@/i18n/en-us/components/salesChannelManagementApp/stock";
import { settings } from "@/i18n/en-us/components/salesChannelManagementApp/settings";
import { woocommerce } from "@/i18n/en-us/components/salesChannelManagementApp/woocommerce";
import { category } from "@/i18n/en-us/components/salesChannelManagementApp/category";
import { migration } from "@/i18n/en-us/components/salesChannelManagementApp/migration";
import { test } from "@/i18n/en-us/components/salesChannelManagementApp/test";
import { bigcommerce } from "@/i18n/en-us/components/salesChannelManagementApp/bigcommerce";
import { reporting } from "@/i18n/en-us/components/salesChannelManagementApp/reporting";
import { productSelection } from "@/i18n/en-us/components/salesChannelManagementApp/productSelection";
import { shopware6 } from "@/i18n/en-us/components/salesChannelManagementApp/shopware6";
import { otto } from "@/i18n/en-us/components/salesChannelManagementApp/otto";
import { journal } from "@/i18n/en-us/components/salesChannelManagementApp/journal";
import { offer } from "@/i18n/en-us/components/salesChannelManagementApp/offer";
import { helpArea } from "@/i18n/en-us/components/salesChannelManagementApp/helpArea";
import { links } from "@/i18n/en-us/components/salesChannelManagementApp/links";
import { saveDialog } from "@/i18n/en-us/components/salesChannelManagementApp/saveDialog";
import { easyCompliance } from "@/i18n/en-us/components/salesChannelManagementApp/easyCompliance";
import { auth } from "@/i18n/en-us/components/salesChannelManagementApp/auth";
import { integrationStatus } from "@/i18n/en-us/components/salesChannelManagementApp/integrationStatus";
import { ebay } from "@/i18n/en-us/components/salesChannelManagementApp/ebay";
import { kaufland } from "@/i18n/en-us/components/salesChannelManagementApp/kaufland";
import { woltdelivery } from "@/i18n/en-us/components/salesChannelManagementApp/woltdelivery";
import { exact } from "@/i18n/en-us/components/salesChannelManagementApp/exact";
import { gambio } from "@/i18n/en-us/components/salesChannelManagementApp/gambio";
import { bexio } from "@/i18n/en-us/components/salesChannelManagementApp/bexio";
import { etsy } from "@/i18n/en-us/components/salesChannelManagementApp/etsy";
import { abaninja } from "@/i18n/en-us/components/salesChannelManagementApp/abaninja";

export const salesChannelManagementApp = {
  active: "Active",
  activeHelp: "Is the workflow active?",
  account: "Revenue account",
  addIntegration: "New integration",
  advancedPricing: "Advanced price setting",
  all: "All",
  auth: auth,
  amazon: amazon,
  exact: exact,
  bexio: bexio,
  etsy: etsy,
  abaninja: abaninja,
  gambio: gambio,
  ebay: ebay,
  tiktok: tiktok,
  woltdelivery: woltdelivery,
  "mollie-pos": molliePos,
  easyCompliance: easyCompliance,
  apiKey: "API Key",
  apiKeyHelp: "Authentication data 1",
  appSaved: "The integration {integrationName} has been saved.",
  articleCount: "Article count",
  assignment: "Category assignment",
  assignmentSelectManual: "Manual assignment table",
  assignmentStrategyManual: "Manual assignment table",
  assignmentTableShop: "{appName}",
  assignmentTableXentral: "Xentral",
  authFailed: "Signing in to Connect failed. Please try again.",
  authRetry: "Re-authenticate",
  authorize: "Authorize",
  authModeToggle: "Automatically generate a token",
  authHelpText:
    "When you click on the button, an access token for {appName} is automatically generated via the Xentral-ERP Connector when the integration is created.",
  authModeToggleInfo:
    "When enabled, an access token for {appName} will be automatically generated via the Xentral-ERP Connector during integration setup. When disabled, you can manually enter your shop credentials.",
  autoAcceptOrders: "Accept orders automatically",
  autoAcceptOrdersHelp:
    "Here you can specify whether new orders in the marketplace should be accepted automatically.",
  back: "Back",
  helpArea: helpArea,
  links: links,
  backToOverview: "Overview",
  baseData: "Master data (excl. prices and stocks)",
  baseSettings: "Base settings",
  bigcommerce: bigcommerce,
  calculateStock: "Calculate stock",
  cancellation: "Cancellation",
  cancellationStates: "Shop-side cancellations",
  carrier: "Carrier",
  carrierAssignment: "Carrier assignment",
  category: category,
  categoryAssignment: "Category assignment",
  categoryLabel: "Category",
  changeActiveStatusTextActive:
    "Attention! If you activate your integration, data is automatically synchronized with your store. This change will not take effect until the next save.",
  changeActiveStatusTextInactive:
    "Attention! If you activate your integration, data is not automatically synchronized with your store anymore. This change will not take effect until the next save.",
  changeActiveStatusTitle: "Change integration mode?",
  clientId: "Client ID",
  clientSecret: "Client Secret",
  collection: "Collection",
  country: "Country",
  countryAssignment: "Country assignment",
  credentials: "Access data",
  currency: "Currency",
  currencyAssignment: "Currency assignment",
  customField: "Free field",
  customFieldAssignment: "Free field assignment",
  customFields: "Free fields",
  customer: "Customer assignment",
  customerGroup: "customer group",
  customers: "Customer assignment",
  content: "Goods/service inspection",
  dataTypes: "Data types",
  dataTypesHelp: "Which data types should be transferred?",
  date: "Date",
  deltaTransmission: "Delta transmission",
  deltaTransmissionHelp: "Which items should be transferred?",
  deliveryTime: "Delivery time",
  deliveryNote: "Delivery Note",
  descriptions: {
    baseData: "Add here the base data of your new integration.",
    credentials: "Connect the systems.",
    features: "Activate your features.",
    tbOneChannelSelection: "Select your TB.One channels",
    sftpData: "Enter your SFTP data"
  },
  depositProduct: "Deposit",
  discountProduct: "Discounts",
  discounts: "Credit notes & discounts",
  exportActive:
    "Your integration is being prepared. Please be patient. As soon as the integration is ready, you can configure it here.",
  exportRules: "Export rules",
  examination: "Examination",
  featureCategory: "Match categories (Xentral > sales channel)",
  featureOffer:
    "Synchronize offers (incl. prices and stocks) (Xentral > sales channel)",
  featureOrders: "Synchronize orders (sales channel > Xentral)",
  featurePrices: "Compare prices (Xentral > sales channel)",
  featureProduct:
    "Synchronize articles (excl. prices and stocks) (Xentral > sales channel)",
  featureRequired: "Please select at least one feature",
  featureStock: "Synchronize stocks (Xentral > sales channel)",
  featureTracking:
    "Synchronize order statuses and tracking (Xentral > sales channel)",
  featureReceipt: "Synchronize receipts (Xentral > sales channel)",
  featurePaymentTransactions:
    "Synchronize payment transactions (Xentral > sales channel)",
  features: "Features",
  feed: "Tracking feed",
  freeFieldAssignment: "Account assignment",
  group: "Product group",
  help: "<div>Having trouble?</div><div>Visit our <a href='https://help.xentral.com/' target='_blank'>Helpcenter</a></div>",
  info: "Note",
  integrationStatus: integrationStatus,
  initArticleImport: "Initial article import",
  initialFile: {
    generateInitialFile: "Generate initial file",
    dialogTitle: "Initial file",
    productDialogInfo:
      "An import file is required for the initial mapping of your product data in Hornbach/Mirakl. Make sure that it contains enough articles so that all assigned article categories are included at least once.",
    offerDialogInfo:
      "Here you can create a CSV file with offers for the initial import.",
    building: "The initial import file is created",
    buildingInfo:
      "As soon as the initial import file has been created, you can download it via the link shown above.",
    limit: "Limit",
    all: "All",
    failed:
      "The last status message is older than one hour. The creation of the initial import file may have been cancelled and can be restarted.",
    started:
      "The creation of the initial import file has been started. It may take a few minutes until the status is available."
  },
  initialFileCreatedAt: "Last created at",
  initialFileName: "Link to the file",
  initialImportFile: "Initial importfile",
  integration: {
    dev: "This integration is in development mode.",
    live: "This integration is in production mode"
  },
  integrationActiveHelp: "Is this integration active?",
  journal: journal,
  key: "Consumer Key",
  keyword: "Keyword",
  language: "Language",
  languageAssignment: "Language assignment",
  layout: "Layout of the product page",
  lineItems: "Order items",
  liveDevMode: "Integration mode",
  livemode: "Production mode",
  livemodeActive: "Activate production mode",
  livemodeError: "Activation failed. Fill in all marked mandatory fields.",
  location: "Sales channel locations",
  loadIntegration:
    "Your integration will be loaded. This process may take some time.",
  mail: "Mail dispatch",
  manual: "Manual",
  markReady: "Mark as ready",
  marketPlace: "Market place",
  marketPlacePlural: "Market places",
  marketplaceLanguageAssignment: "Language assignment",
  media: "Media",
  metaTexts: "Meta texts",
  migration: migration,
  mode: "Mode",
  modeHelp: "Is the integration being used live?",
  name: "Name of the integration",
  nameHelp:
    "What should the new integration be named? Please note that the integration name must be unique.",
  newTokenSuccess: "New token successfully generated.",
  next: "Next",
  no: "No",
  noConfigAvailable: "No configuration available",
  notification: "Notifications",
  of: "of",
  offer: offer,
  onChange: "On change",
  onlineStatus: "Online status",
  openingTimes: "Opening times",
  orderStates: "Shop order states",
  orders: orders,
  otto: otto,
  password: "Password / API-Key",
  passwordHelp: "Authentication data 2",
  payment: "Payment methods",
  paymentAndShippingState: "Payment and shipping status",
  paymentMethod: "Payment method",
  paymentMethods: "Payment methods",
  paymentState: "Payment status",
  pos: "POS customers",
  position: "Positions",
  priceRule: "Price rules",
  priceSelection: "Price selection",
  specialPriceSelection: "Special price selection",
  priceTitle: "Prices",
  prices: prices,
  product: product,
  productAssignment: "Product assignment",
  productAssignmentTarget: "Field from {appName}",
  productBaseData: "Master data",
  productSelection: productSelection,
  productSelectionTable: {
    id: "ID",
    name: "Name",
    productNumber: "Article no.",
    ean: "EAN no. / barcode",
    isDisabled: "Lock active",
    projectId: "Project ID",
    merchandiseGroupId: "Article category ID"
  },
  project: "Project",
  projectHelp: "Which project in Xentral is the integration assigned to?",
  properties: "Properties",
  publication: "Sales Channel",
  remark: "Comments",
  reporting: reporting,
  returnStates: "Return states",
  returns: "Returns",
  salesChannelAssignment: "Project assignment",
  salesChannels: "Sales channels",
  save: "Save",
  saveIntegration:
    "Your integration will be created. This process may take some time.",
  secret: "Consumer Secret",
  settings: settings,
  salesOrder: "Orders",
  shipFromAddress: "Warehouse address for order status and tracking feedback",
  shipping: "Shipping methods & delivery terms",
  shippingCosts: "Shipping costs",
  shippingCostsDiscountsTaxes: "Shipping costs, discounts and taxes",
  shippingMethod: "Shipping method",
  shippingMethods: "Shipping methods",
  shippingProduct: "Shipping costs",
  general: "General",
  giftWrapProduct: "Gift wrap product",
  shippingState: "Shipping status",
  shop: "Online shop",
  shopPlural: "Online shops",
  shopify: shopify,
  shopware6: shopware6,
  kaufland: kaufland,
  softMigrationSuccess: "Placeholder integration successfully created",
  stateOfTransfer: "Status for transfer",
  steps: "Step",
  stock: stock,
  stockTitle: "Stock",
  storageDeliveryConfig: "Storage and delivery configuration",
  surchargeProduct: "Surcharges",
  supplier: "Supplier",
  taxes: "Taxes",
  taxationMappingTableId: "Taxation mapping",
  test: test,
  timeBased: "Time-based",
  timeOfTransfer: "Time of transfer",
  timeOfTransferHelp: "How and when is the transfer triggered?",
  timings: "Interval for new orders",
  title: {
    journals: "Journals and accounts",
    synchronization: "Synchronization"
  },
  journals: "Journals",
  synchronization: "Debtor synchronisation",
  dataFields: "Data fields",
  paymentMapping: "Payment methods",
  accountMapping: "{appName} document type",
  paymentStatus: "{appName} payment status",
  costCenterMapping: "Cost center",
  vatMapping: "VAT mapping",
  taxRateMapping: "VAT",
  currencyMapping: "Currency",
  projectMapping: "Projects",
  titles: {
    accounting: "Accounting",
    additionalSettings: "Further settings",
    debtors: "Debtors",
    creditors: "Creditors",
    articles: "Articles",
    salesInvoices: "Sales invoices",
    creditNotes: "Credit notes",
    liabilities: "Purchase invoices",
    taxes: "Tax rates & VAT",
    projects: "Projects",
    baseData: "Base data",
    baseSettings: "Base settings",
    category: "Category",
    credentials: "Access data",
    dashboard: "Dashboard",
    features: "Features",
    journal: "Products",
    prices: "Prices",
    pos: "pos",
    product: "Product",
    tbOneChannelSelection: "TB.One Channel",
    productSelection: {
      selection: "Product selection",
      configure: "Configure filter"
    },
    reporting: "Reporting",
    salesOrder: "Orders",
    salesOrder_payment: "Payment methods",
    salesOrder_shipping: "Shipping methods",
    settings: {
      title: "Settings",
      wizard: "Basic settings",
      productAssignment: "Article assignment",
      productSelection: "Article selection",
      advanced: "Advanced settings",
      shop: "Shop",
      externalReferences: "External references",
      taxes: "Taxes",
      businessAddress: "Business address"
    },
    system: "System Features",
    title: {
      stock: "Stock",
      price: "Prices",
      initialImportFile: "Initial import file",
      initialImportFileSettings: "Initial importfile settings",
      general: "General"
    },
    trackingReturns: "Tracking returns",
    stock: "Stock",
    tracking: "Order status & tracking",
    migration: {
      title: "Initial data import",
      strategy: "Migration strategy",
      settings: "Settings"
    },
    sftpData: "SFTP-Data",
    offer: "Offers",
    receipt: "Receipts",
    paymentTransactions: "Payment transactions",
    venue: "Venue"
  },
  posAssignment: "Terminal Assignment",
  token: "Token",
  tracking: tracking,
  updateStrategy: "Update strategy",
  updateStrategyHelp: "How and when is the transfer triggered?",
  url: "URL",
  urlHelp: "URL of the system to be connected",
  useFilter: "Use filter",
  useFilterForAllProducts: "Apply filter for all products",
  useFilterForSelectedProducts: "Apply filter for selected products",
  usedFilters: "Filters used so far",
  username: "Username",
  validateCredentials: "Test connection",
  voucherProduct: "Vouchers",
  skipValidation: "Skip validation",
  getTokenByOAuth: "Generate token via {name}",
  validateSftpData: "Test sftp data",
  validateCredentialsError:
    "Please check that correct credentials have been entered",
  validateCredentialsSuccess: "The connection could be established.",
  value: "Value",
  vatMappingTableId: "VAT mapping",
  warehouse: "Warehouse",
  wizardError: "There was an error creating the integration.",
  wizardSaving: "Your new store integration is being created...",
  wizardSuccess: "The integration {integrationName} was successfully created.",
  wizardSalesChannelNotCreated:
    "The integration {integrationName} was created. However, no suitable sales channel could be created. Please contact support.",
  woocommerce: woocommerce,
  workflows: "Workflows",
  xentral: "Xentral",
  yes: "Yes",
  invoices: "Invoices",
  creditNotes: "Credit notes",
  saveDialog: saveDialog,
  uniqueName: "The name of the integration must be unique.",
  invalidOption:
    "This option is not available because it has either been removed in your sales channel or in Xentral. Please remove this option.",
  invalidOptions: "There are invalid values in the configuration."
};
